/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_mt_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What if my text contains a pipe (|)?`)
};

const es_mt_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué pasa si mi texto contiene una barra (|)?`)
};

const de_mt_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ist, wenn mein Text ein Pipe-Zeichen (|) enthält?`)
};

const nl_mt_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat als mijn tekst een pijp (|) bevat?`)
};

const fr_mt_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Et si mon texte contient une barre verticale (|) ?`)
};

const it_mt_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E se il mio testo contiene una barra verticale (|)?`)
};

const pt_br2_mt_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E se meu texto contiver um pipe (|)?`)
};

const pt_mt_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E se o meu texto contiver um pipe (|)?`)
};

const ja_mt_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テキストにパイプ（|）が含まれている場合はどうなりますか？`)
};

const zh_mt_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如果我的文本中包含竖线（|）怎么办？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const mt_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.mt_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("mt_faq2_q", locale)
	if (locale === "en") return en_mt_faq2_q(inputs)
	if (locale === "es") return es_mt_faq2_q(inputs)
	if (locale === "de") return de_mt_faq2_q(inputs)
	if (locale === "nl") return nl_mt_faq2_q(inputs)
	if (locale === "fr") return fr_mt_faq2_q(inputs)
	if (locale === "it") return it_mt_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_mt_faq2_q(inputs)
	if (locale === "pt") return pt_mt_faq2_q(inputs)
	if (locale === "ja") return ja_mt_faq2_q(inputs)
	return zh_mt_faq2_q(inputs)
};